import { Navigate } from 'react-router-dom';

import RoomDisconnectedPage from 'pages/RoomDisconnectedPage/RoomDisconnectedPage';
import { FeatureFlag } from 'utils/Constants';
import lazyWithRetry from 'utils/lazyWithRetry';

import { APP_ROUTES, ROOM_ROUTE_PATTERNS } from './routePaths';
import { createRoutes } from './utils/createRoute';
import withBrowserCheck from './utils/withBrowserCheck';
import withFeatureFlag from './utils/withFeatureFlag';
import withPageWrapper from './utils/withPageWrapper';

const pages = {
  UnsupportedBrowser: lazyWithRetry(() => import('modules/UnsupportedBrowser/UnsupportedBrowser')),
  MainPage: lazyWithRetry(() => import('pages/MainPage/MainPage')),
  RoomPage: lazyWithRetry(() => import('pages/RoomPage/RoomPage')),
  RoomEndedPage: lazyWithRetry(() => import('pages/RoomEndedPage/RoomEndedPage')),
  RoomTerminatedPage: lazyWithRetry(() => import('pages/RoomTerminatedPage/RoomTerminatedPage')),
  AuthenticationPage: lazyWithRetry(() => import('pages/AuthenticationPage/AuthenticationPage')),
  WorkspaceInvitePage: lazyWithRetry(() => import('pages/WorkspaceInvitePage/WorkspaceInvitePage')),
  DiagnosticsPage: lazyWithRetry(() => import('pages/DiagnosticsPage/DiagnosticsPage')),
  CalendarAuthCallback: lazyWithRetry(() => import('pages/CalendarAuthCallback/CalendarAuthCallback')),
};

export default createRoutes([
  {
    path: [
      APP_ROUTES.root,
      APP_ROUTES.calendar,
      APP_ROUTES.messenger,
      APP_ROUTES.messengerRoom,
      APP_ROUTES.meetings,
      APP_ROUTES.meetingDetail,
    ],
    component: pages.MainPage,
    hocs: [withPageWrapper({ isFullPageScroll: false })],
  },
  {
    path: ['/auth/callback', '/auth/microsoft-callback'],
    component: pages.CalendarAuthCallback,
    hocs: [withPageWrapper()],
  },
  {
    path: APP_ROUTES.unsupportedBrowser,
    component: pages.UnsupportedBrowser,
  },
  {
    path: ROOM_ROUTE_PATTERNS,
    component: pages.RoomPage,
    hocs: [withBrowserCheck],
    children: [
      { path: '/end', component: pages.RoomEndedPage },
      { path: '/disconnected', element: <RoomDisconnectedPage /> },
      { path: '/terminated', component: pages.RoomTerminatedPage },
    ],
  },
  {
    path: APP_ROUTES.invite,
    component: pages.WorkspaceInvitePage,
    hocs: [withPageWrapper(), withFeatureFlag(FeatureFlag.WORKFLOWS)],
  },
  {
    path: APP_ROUTES.authRoot,
    component: pages.AuthenticationPage,
    hocs: [withPageWrapper()],
  },
  {
    path: APP_ROUTES.authWildcard,
    element: <Navigate to={APP_ROUTES.authRoot} replace />,
  },
  {
    path: APP_ROUTES.diagnosticsTest,
    component: pages.DiagnosticsPage,
    hocs: [withPageWrapper()],
  },
]);
